import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { ArrowLeft, FileText } from "lucide-react";

export default function Terms() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col bg-cream" data-testid="terms-page">
      <Navbar />
      <main className="section flex-1">
        <div className="container-app max-w-3xl">
          <Link to="/" className="fx-btn fx-btn--ghost text-sm mb-4 inline-flex" data-testid="back-home">
            <ArrowLeft size={14} /> {t("common.backHome")}
          </Link>
          <div className="flex items-center gap-2 mb-2">
            <FileText className="text-hive-ink" />
            <h1 className="font-display text-4xl md:text-5xl font-extrabold text-worker">{t("legal.terms.title")}</h1>
          </div>
          <p className="text-smoke">{t("legal.effective")}</p>

          <div className="card-base p-4 mt-6 bg-linen border-sand">
            <p className="text-sm text-worker"><Trans i18nKey="legal.draftBadge" components={{ strong: <strong />, em: <em /> }} /></p>
          </div>

          <section className="mt-8 space-y-6 text-worker">
            <Block title={t("legal.terms.s1Title")}>{t("legal.terms.s1Body")}</Block>
            <Block title={t("legal.terms.s2Title")}>{t("legal.terms.s2Body")}</Block>
            <Block title={t("legal.terms.s3Title")}>{t("legal.terms.s3Body")}</Block>
            <Block title={t("legal.terms.s4Title")}>
              <ul className="list-disc list-inside space-y-1 text-sm">
                <li>{t("legal.terms.s4l1")}</li>
                <li>{t("legal.terms.s4l2")}</li>
                <li>{t("legal.terms.s4l3")}</li>
                <li>{t("legal.terms.s4l4")}</li>
              </ul>
            </Block>
            <Block title={t("legal.terms.s5Title")}>{t("legal.terms.s5Body")}</Block>
            <Block title={t("legal.terms.s6Title")}>{t("legal.terms.s6Body")}</Block>
            <Block title={t("legal.terms.s7Title")}>{t("legal.terms.s7Body")}</Block>
            <Block title={t("legal.terms.s8Title")}>{t("legal.terms.s8Body")}</Block>
            <Block title={t("legal.terms.s9Title")}>{t("legal.terms.s9Body")}</Block>
            <Block title={t("legal.terms.s10Title")}>{t("legal.terms.s10Body")}</Block>
            <Block title={t("legal.terms.s11Title")}>{t("legal.terms.s11Body")}</Block>
            <Block title={t("legal.terms.s12Title")}>
              <Trans
                i18nKey="legal.terms.s12Body"
                components={{ a: <a className="text-hive-ink hover:underline" href="mailto:support@fixydany.com" /> }}
              />
            </Block>
            {/* The AI disclosure is its own numbered section rather than a line
                inside another one: it is a thing the user is asked to accept,
                so it needs a heading they can point at. */}
            <Block title={t("legal.terms.s13Title")}>{t("legal.terms.s13Body")}</Block>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl font-bold text-worker mb-1">{title}</h2>
      <div className="text-sm text-worker/90 leading-relaxed">{children}</div>
    </div>
  );
}
